angular.module('rjmNg.directives').directive "reportBuilderScalar", [
  () ->
    restrict: "E"
    templateUrl: "directive.reportBuilderScalar.html"
    replace: true
    scope:
      metrics: "="
      metric: "="
      timeRange: "="
      editMetricAlias: "="
      displayedFigure: "="
    controller: [
      "$q"
      "$scope"
      "$routeParams"
      "reportBuilderScalarService"
      "rjql"
      "utils"
      "app"
      (
        $q
        $scope
        $routeParams
        reportBuilderScalarService
        rjql
        utils
        app
      ) ->

        $scope.singleMeasureFigure = null
        $scope.waitingForUpdate = false
        $scope.error = false
        RJQL_VERSION = app.getRjqlVersion()
        $scope.clientId = $routeParams.clientId
        queryDeferred = null

        update = () ->
          if $scope.metric? and $scope.displayedFigure? and not $scope.editMetricAlias
            # Don't send a query for an invalid formula metric
            return if $scope.metric.type is 'formula' and
              (not $scope.metric.valid or $scope.metric.valid is 'blank')

            # Cancel the previous query if its still pending
            if queryDeferred?
              queryDeferred.reject({status: -1})
            queryDeferred = $q.defer()

            query = reportBuilderScalarService.generateScalarQuery(
              $scope.metrics, $scope.metric
              $scope.timeRange
              RJQL_VERSION
            )

            figure = reportBuilderScalarService.getSingleMeasureFigure(
              $scope.displayedFigure
              query
            )

            $scope.waitingForUpdate = true

            rjql.runQueryCached(
              $scope.clientId,
              query,
              queryDeferred,
              RJQL_VERSION,
              app.hasFeatureFlag('RJQL_SERVICE_DEBUG')
            ).then (success) ->
              timedOut = success.data.warnings?.filter((warning) ->
                warning.code is 1002)
              .length > 0
              $scope.error = timedOut
              figure.data = success.data
              $scope.singleMeasureFigure = utils.copy(figure)
              $scope.waitingForUpdate = false
            , (error) ->
              unless utils.requestWasCanceled(error)
                $scope.error = true
                $scope.singleMeasureFigure = null
                $scope.waitingForUpdate = false

        $scope.$watch 'metric', () ->
          update()
        , true

        $scope.$watch 'displayedFigure', () ->
          update()
        , true

    ]

]
